import styles from "./styles.module.scss";
import {useCallback, useEffect, useRef, useState} from "react";
import cn from "classnames";
import {Icon} from "@shopify/polaris";
import FeatureImg from "./FeatureImg";
import useMobile from "../../../../helpers/hooks/useMobile";
import {useIntersectionObserver} from "../../../../helpers/hooks/useIntersection";

const secondsInterval = 5;
const FeaturesTemplate = ({cards, imgList, namespace}) => {
  const [currentCard, setCurrentCard] = useState(0);
  const [isClicked, setIsClicked] = useState(false);
  const isMobile = useMobile(767)
  const isNoTransition = useMobile(959);

  const featuresRef = useRef(null);
  const onScreen = useIntersectionObserver(featuresRef, {rootMargin: "0px", threshold: [0.5]})

  const handleCardClick = useCallback((currentCard) =>
    () => {
      setCurrentCard(currentCard);
      setIsClicked(true);
    }, [currentCard])

  useEffect(() => {

    if (!onScreen) {
      return;
    }

    if (isClicked) {
      return;
    }

    if (isMobile || isNoTransition) {
      setCurrentCard(0); //unset active card
      return;
    }

    let times = 0;
    const timer = setInterval(() => {
      setCurrentCard(times);
      times += 1;

      if (times === cards.length) {
        times = 0;
      }

    }, secondsInterval * 1000);
    return () => clearTimeout(timer);
  }, [isMobile, isClicked, onScreen])

  return (
    <section className={cn(styles["features"], "features")} id="nextStep">
      <div className={styles["features__container"]}>
        <div className={styles["features__cards-wrapper"]} ref={featuresRef}>
          <ul className={styles["features__cards"]}>
            {cards.map((el, i) => (
              <li
                className={cn(styles["features__card"], styles["card"], {[styles["card--active"]]: (currentCard === i)}, {[styles["card--without-icon"]]: !el.icon})}
                key={i} onClick={handleCardClick(i)}>
                <div className={styles["card__header-wrapper"]}>
                  {el.icon &&
                    <div className={styles["card__icon-wrapper"]}>
                      <Icon source={el.icon}/>
                    </div>
                  }
                  <h3 className={styles["card__header"]}>{el.title}</h3>
                </div>
                <p className={styles["card__desc"]}>{el.desc}</p>
              </li>
            ))}
          </ul>
        </div>
        {
          cards.map((el, i) => (
            currentCard === i && <FeatureImg key={i} img={imgList[i]}/>
          ))
        }
      </div>
    </section>
  );
};

export default FeaturesTemplate;